export default __webpack_public_path__ + "static/media/bg-large-blue-light.6147fed1.svg";